export default __webpack_public_path__ + "static/media/bg.6fe24fc4.webp";